module.exports = __webpack_public_path__ + "public/1.0.1_701555/img/txt.9cdab9ae.svg";